<template>
<span>
    <slot>

    </slot>
</span>
</template>
<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            _descr: 'Disabled to open tooltip',
        },
        cursorOffsetX: {
            default: 10,
        },
        cursorOffsetY: {
            default: 20,
        },
        content: {},
    },
    mounted () {
        let base = this.$root.$el.querySelector('[tooltip-follow-base]')

        this.$el.addEventListener('mousemove', (event) => {
            if (this.disabled) {
                return
            }

            base.style.setProperty('top', event.clientY + this.cursorOffsetY + 'px', 'important')
            base.style.setProperty('left', event.clientX + this.cursorOffsetX + 'px', 'important')
        })

        this.$el.addEventListener('mouseenter', (event) => {
            base.style.setProperty('display', 'block', 'important')
            base.innerHTML = this.content
        })

        this.$el.addEventListener('mouseleave', (event) => {
            base.style.setProperty('display', 'none', 'important')
        })
    },
}
</script>
